import { createAction } from 'redux-actions';

export type ModuleConfigPayload = {
  moduleId: number;
};

export const fetchModuleDataSuccess = createAction(
  'MODULE.FETCH.SUCCESS',
  payload => payload
);

export const updateModule = createAction('MODULE.UPDATE', payload => payload);

export const fetchModuleConfig = createAction<ModuleConfigPayload>(
  'MODULE.CONFIG.FETCH'
);

export const fetchModuleConfigSuccess = createAction(
  'MODULE.CONFIG.FETCH.SUCCESS',
  payload => payload
);

export const saveModuleConfig = createAction(
  'MODULE.CONFIG.SAVE',
  payload => payload
);
